export default __webpack_public_path__ + "static/illu_student3-0804d51cb6b58f39844d2821aa02210f.jpg";